import { Map } from 'immutable'
import * as API from '../../utils/API'
import { loading, loadingSuccess, loadingFailure } from './status'
import mergePayload from './utils/mergePayload'
import toQueryString from './utils/toQueryString'

const RESOURCE_NAME = 'pldMedio'
const ENDPOINT = '/indicativos/medios/periodo'
const ENDPOINT_ANO = '/indicativos/medios'

const resolve = (dispatch, resource) => {
  dispatch(loadingSuccess(RESOURCE_NAME))
  dispatch(loadingPldMedioSuccess(resource))
  return Promise.resolve(resource)
}

const reject = (dispatch, error) => {
  dispatch(loadingFailure(RESOURCE_NAME, error))
  return Promise.reject(error)
}

export const LOADING_PLD_MEDIO_SUCCESS = 'LOADING_PLD_MEDIO_SUCCESS'
export function loadingPldMedioSuccess(pldMedio) {
  return {
    type: LOADING_PLD_MEDIO_SUCCESS,
    pldMedio,
  }
}

export function fetchMultiplePldMedio(params = {}) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(ENDPOINT + toQueryString(params)).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function updatePldMedioAno(pldMedio) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(ENDPOINT_ANO, 'PUT', pldMedio).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

const pldMedio = (state = new Map({}), action) => {
  switch (action.type) {
    case LOADING_PLD_MEDIO_SUCCESS: {
      const { pldMedio: payload } = action
      return mergePayload(state, payload)
    }

    default:
      return state
  }
}

export default pldMedio
